module.exports = __webpack_public_path__ + "img/upscreen_2.872210c8.jpg";